// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-editor{border:1px solid #ccc;border-radius:5px;padding:10px}", ""]);
// Exports
module.exports = exports;
